import OnBehalfOfOrganizationAdminSwitch from './OnBehalfOfOrganizationAdminSwitch';

export default OnBehalfOfOrganizationAdminSwitch;
